import React from 'react';
import ContactUs from '../../components/ContactUs';
import FavoriteIcon from '@mui/icons-material/Favorite';
import PetsIcon from '@mui/icons-material/Pets';
import NavBar from '../../components/NavBar';
import heroPhoto from '../../asstes/images/bg.png';
export default function LoveOfDogs() {
  return <section className="home-hero">
    <div className="hero-stage">
    <NavBar/>
    <img className="hero-art" src={heroPhoto} alt="Two neighbors sharing time with a dog"/>
    <div className="hero-content">
      <h1 aria-label="Share the Love of Dogs!"><span className="hero-title-desktop">Share the Love of Dogs!</span><span className="hero-title-mobile" aria-hidden="true">Share the<span><FavoriteIcon/> of Dogs</span></span></h1>
      <p>Connecting<br/>Neighbors to<br/>Share Dogs</p>
      <a className="paws-button hero-join" href="https://webapp.socialpawsapp.com/" target="_blank" rel="noopener noreferrer"><span>Join our</span><span>Neighborhood App!</span></a>
    </div>
    </div>
    <div className="compact-hero-intro">
      <p><span>Connecting Neighbors</span><span>to Share Dogs <PetsIcon aria-hidden="true"/></span></p>
      <a className="paws-button compact-join" href="https://webapp.socialpawsapp.com/" target="_blank" rel="noopener noreferrer"><span>Join our</span><span>Neighborhood App!</span></a>
    </div>
    <ContactUs/>
  </section>;
}
